import { render, staticRenderFns } from "./own-approval.vue?vue&type=template&id=c2f1182a"
import script from "./own-approval.vue?vue&type=script&lang=ts"
export * from "./own-approval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports